/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Checkout_Verified_ToastInputs */



/**
* | output |
* | --- |
* | "Subscription activated successfully!" |
*
* @param {Creator_Checkout_Verified_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_checkout_verified_toast = /** @type {((inputs?: Creator_Checkout_Verified_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Checkout_Verified_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Abonnement active avec succes !")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abonnement erfolgreich aktiviert!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abbonamento attivato con successo!")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подписка успешно активирована!")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Suscripción activada exitosamente!")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("订阅已成功激活！")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプションが正常に有効化されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्यता सफलतापूर्वक सक्रिय हो गई!")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Assinatura ativada com sucesso!")
	return /** @type {LocalizedString} */ ("Subscription activated successfully!")
});